enum OctopusJournalType {
  Buy = 'Buy',
  Sell = 'Sell',
  Financial = 'Financial',
  Miscellaneous = 'Miscellaneous',
}

export default OctopusJournalType;
